(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-zoom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const heading = document.querySelector('.text-lens-zoom .appear-content h2');
  let scale = 1;
  const minScale = 1;
  const maxScale = 3;
  const totalScrollSteps = 12; // ✅ total scrolls to complete zoom
  let scrollCount = 0;

  window.addEventListener('wheel', function(e) {
    const container = document.querySelector('.text-lens-zoom');
    const bounding = container.getBoundingClientRect();

    // Only trigger inside visible section
    if (bounding.top < window.innerHeight && bounding.bottom > 0) {
      // Scroll down → zoom in
      if (e.deltaY > 0 && scrollCount < totalScrollSteps) {
        e.preventDefault();
        scrollCount++;
      }

      // Scroll up → zoom out
      if (e.deltaY < 0 && scrollCount > 0) {
        e.preventDefault();
        scrollCount--;
      }

      // Calculate progress (0 → 1)
      const progress = scrollCount / totalScrollSteps;

      // Map progress to scale and opacity
      scale = minScale + (maxScale - minScale) * progress;
      const opacity = 1 - progress;

      // Apply to heading
      heading.style.transition = 'transform 0.4s ease-out, opacity 0.4s ease-out';
      heading.style.transform = `scale(${scale})`;
      heading.style.opacity = opacity;

      // Update CSS variables (optional for styling)
      heading.style.setProperty('--scale-change-ratio', scale.toFixed(6));
      heading.style.setProperty('--opacity-change-ratio', opacity.toFixed(6));
    }
  }, { passive: false });
});

  } catch(e) { console.error(e); }
})();
})();
